import type { ISwSettings } from "app/@types/ISwSettings";

const DHL_COMPANY_DOMAIN = "dhl.com";

export const isDhlUser = (settings: ISwSettings): boolean =>
    settings.user.username?.split("@")[1]?.toLowerCase() === DHL_COMPANY_DOMAIN;
